import { AnswerEntity, RawAnswer } from './Types';
import { BaseModel } from '../BaseModel/BaseModel';

export class AnswerModel
    extends BaseModel<RawAnswer, AnswerEntity>
    implements AnswerEntity
{
    selected: boolean = false;
    title: string = '';
    value: number | string = 0;

    constructor(answer?: RawAnswer) {
        super();
        if (answer) {
            this.initialize(answer);
        }
    }

    initialize(answer: RawAnswer) {
        this.selected = answer.selected;
        this.title = answer.title;
        this.value = answer.value;
    }

    parse(): RawAnswer {
        return {
            selected: this.selected,
            title: this.title,
            value: this.value,
        };
    }

    updateInputValue(newValue: string) {
        this.value = newValue;
        this.selected = true;
        this.title = newValue;
    }

    updateSelectValue(isSelected: boolean) {
        this.selected = isSelected;
    }
}
